import { useRef } from 'react'
import styles from './FooterCTA.module.scss';
import Button from 'components/common/Button/Button';
import animationStyles from 'components/common/Animation/Animation.module.scss';
import useElementVisible from 'components/common/Animation/useElementVisible';

const FooterCTA: React.FunctionComponent = () => {
  const textRef = useRef<HTMLDivElement>(null);
  const isVisible = useElementVisible(textRef, 0.1);

  return (
    <section className={`${styles.footerCTA} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`} ref={textRef}>
      <div className={styles.footerCTA__anime}>
        <h2 className={styles.footerCTA__title}>Always on Mission</h2>
        <p className={styles.footerCTA__text}>共に考え、共に創るパートナーとして、<br className={styles.none} />各分野の専門家が最適な道を描きます。<br />ぜひ1度、ビジョンやお悩みを<br className={styles.none} />お聞かせください。</p>
        <div className={styles.footerCTA__btn}>
          <Button text="相談してみる" href="/contact" middleRed='middleRed' />
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;
